export default __webpack_public_path__ + "static/media/summary_planimages_84b.bfc90aba.png";